import React from "react";
import classes from "./Fees.module.css";

const Fees = () => {
    return (
        <div className={classes.Intro}>
            <h1 className={classes.focusLine}>
                <span>Fees</span>
            </h1>
            <div className={classes.container1}>
                <div>
                    <h4>Initial Examination (with treatment)</h4>
                    <p>$120</p>
                    <p>
                        A patient's first visit to the clinic! This 60 minute treatment
                        includes a thorough history, physical examination and treatment.
                    </p>
                    <h4>Subsequent Chiropractic Visit</h4>
                    <p>$60 - 30 mins</p>
                    <p>
                        Chiropractic treatment involving various modalities and treatment
                        interventions, including mobilizations, adjustments, soft tissue,
                        acupuncture and rehabilitation.
                    </p>
                    <h4>Extended chiropractic Visit</h4>
                    <p>$85 - 45 mins</p>
                    <p>$110 - 60 mins</p>
                    <p>
                        This is for patients who have not been to the clinic is the last 6
                        months, have multiple areas of concern, or who have a new complaint
                        that needs to be examined.
                    </p>
                    <h4>Fascial stretch Therapy</h4>
                    <p>
                        $85 - 45 mins
                        <br/>
                        $110 - 60 mins
                        <br/>
                        $150 - 90 mins
                    </p>
                    <p>Patients must have received initial exam prior to bookings FST.</p>
                    <h4>Custom Orthotics ($500)</h4>
                    <p>$75 - 30 mins</p>
                    <p>Biomechanical exam and gait analysis</p>
                    <p>$425</p>
                    <p>Custom orthotics Partnered with The Orthotic Group.</p>
                </div>
                <h4>Massage</h4>
                <p>
                    45 minute massage (HST included) $84.75 <br/>
                    60 minute massage (HST included) $113.00 <br/>
                    90 minute massage (HST included) $169.50
                </p>
                <h4>Physiotherapy</h4>
                <p>Initial Assessement 60 mins - $120</p>
                <p>Subsequent visits:
                    <br/>
                    $120 - 60 mins
                    <br/>
                    $105 - 45 mins
                    <br/>
                    $85 - 30 mins
                </p>
                <h4>Pelvic Floor PT</h4>
                <p>Initial assment $140</p>
                <p>Subsequent visits:
                    <br/>
                    $140 - 60 mins

                    <br/> $120 - 45 mins

                    <br/> $105 - 30 mins
                </p>


            </div>
        </div>
    );
};

export default Fees;